"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCatalogueOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M24 4c-3.5 0-6.1.9-7.52 2.62a5.81 5.81 0 00-.48.66 5.81 5.81 0 00-.48-.66C14.1 4.9 11.5 4 8 4H2v21h8c2.06 0 3.59.47 4.3 1.33a3.21 3.21 0 01.71 2.4V29h2v-.28a3.2 3.2 0 01.71-2.39C18.42 25.47 20 25 22 25h8V4zM10 23H4V6h4c2.84 0 5 .67 6 1.89a4.74 4.74 0 011 3.41v13a8.49 8.49 0 00-5-1.3zm18 0h-6a8.58 8.58 0 00-5 1.28v-13a4.74 4.74 0 011-3.41C19 6.67 21.16 6 24 6h4z" })));
}
exports.default = SvgCatalogueOutline;
//# sourceMappingURL=CatalogueOutline.js.map